import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as MarketplaceActions from './marketplace.actions';
import { catchError, concatMap, filter, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { globalFailure } from './../../../app/@store/common.actions';
import { PublicPartnerApiService } from './../../../app/@shared/services/publicpartnerapi.service';
import { MarketplaceApplication } from './../../../app/@shared/models/marketplace_application.model';

@Injectable()
export class MarketplaceEffects {
  constructor(private readonly actions$: Actions, private readonly api: PublicPartnerApiService) { }

  loadApplications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MarketplaceActions.loadApplications, MarketplaceActions.patchApplicationSuccess, MarketplaceActions.patchApplicationAdminSuccess, MarketplaceActions.createApplicationAdminSuccess, MarketplaceActions.removeApplicationAdminSuccess),
      concatMap(
        action =>
          this.api.get<{ applications: Partial<MarketplaceApplication>[] }>('/partners/##CURRENT_PARTNER_UUID##/marketplace/applications', {}).pipe(
            map((result) => {
              return MarketplaceActions.loadApplicationsSuccess({
                data: result.applications
              });
            }),
            catchError(error => of(MarketplaceActions.loadApplicationsFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  patchApplication$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MarketplaceActions.patchApplication),
      concatMap(
        action =>
          this.api.patch<void>('/partners/##CURRENT_PARTNER_UUID##/marketplace/applications/' + action.uuid, action.data).pipe(
            map(() => {
              return MarketplaceActions.patchApplicationSuccess({
                uuid: action.uuid
              });
            }),
            catchError(error => of(MarketplaceActions.patchApplicationFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  patchApplicationAdmin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MarketplaceActions.patchApplicationAdmin),
      concatMap(
        action =>
          this.api.patch<void>('/partners/##CURRENT_PARTNER_UUID##/marketplace/applications/' + action.uuid + '/admin', action.data).pipe(
            map(() => {
              return MarketplaceActions.patchApplicationAdminSuccess({
                uuid: action.uuid
              });
            }),
            catchError(error => of(MarketplaceActions.patchApplicationAdminFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  createApplicationAdmin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MarketplaceActions.createApplicationAdmin),
      concatMap(
        action =>
          this.api.post<void>('/partners/##CURRENT_PARTNER_UUID##/marketplace/applications/' + action.uuid + '/admin', {}).pipe(
            map(() => {
              return MarketplaceActions.createApplicationAdminSuccess({
                uuid: action.uuid
              });
            }),
            catchError(error => of(MarketplaceActions.createApplicationAdminFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );

  removeApplicationAdmin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MarketplaceActions.removeApplicationAdmin),
      concatMap(
        action =>
          this.api.delete<void>('/partners/##CURRENT_PARTNER_UUID##/marketplace/applications/' + action.uuid + '/admin').pipe(
            map(() => {
              return MarketplaceActions.removeApplicationAdminSuccess({
                uuid: action.uuid
              });
            }),
            catchError(error => of(MarketplaceActions.removeApplicationAdminFailure({ error }), globalFailure({ error })))
          )
      )
    )
  );
}
